import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const DemographicStep = ({ formData, onChange, errors }) => {
  const ageRangeOptions = [
    { value: '18-24', label: '18-24 years' },
    { value: '25-34', label: '25-34 years' },
    { value: '35-44', label: '35-44 years' },
    { value: '45-54', label: '45-54 years' },
    { value: '55-64', label: '55-64 years' },
    { value: '65+', label: '65+ years' }
  ];

  const genderOptions = [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' },
    { value: 'non-binary', label: 'Non-binary' },
    { value: 'prefer-not-to-say', label: 'Prefer not to say' },
    { value: 'other', label: 'Other' }
  ];

  const populationSegmentOptions = [
    { value: 'employee', label: 'Employee' },
    { value: 'student', label: 'Student' },
    { value: 'community-member', label: 'Community Member' },
    { value: 'family-member', label: 'Family Member' }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-foreground mb-2">
          Basic Information
        </h3>
        <p className="text-sm text-muted-foreground">
          Help us understand your background for better matching
        </p>
      </div>
      <Input
        label="Preferred Name"
        type="text"
        placeholder="How would you like to be addressed?"
        value={formData?.preferredName || ''}
        onChange={(e) => onChange('preferredName', e?.target?.value)}
        description="This name will be visible to your helper"
        required
        error={errors?.preferredName}
      />
      <Select
        label="Age Range"
        placeholder="Select your age range"
        options={ageRangeOptions}
        value={formData?.ageRange || ''}
        onChange={(value) => onChange('ageRange', value)}
        description="Optional - helps match with helpers who understand your life stage"
        error={errors?.ageRange}
      />
      <Select
        label="Gender Identity"
        placeholder="Select gender identity"
        options={genderOptions}
        value={formData?.gender || ''}
        onChange={(value) => onChange('gender', value)}
        description="Optional - for matching with helpers who share similar experiences"
        error={errors?.gender}
      />
      <Select
        label="I am a"
        placeholder="Select your role"
        options={populationSegmentOptions}
        value={formData?.populationSegment || ''}
        onChange={(value) => onChange('populationSegment', value)}
        required
        error={errors?.populationSegment}
      />
      <div className="p-4 bg-muted/50 rounded-lg border border-border">
        <p className="text-sm text-muted-foreground">
          <strong className="text-foreground">Privacy Note:</strong> Demographic information is used solely for matching purposes and is never shared without your explicit consent.
        </p>
      </div>
    </div>
  );
};

export default DemographicStep;